import { inView, animate, stagger } from "vendor";
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => {
  if (member.has(obj)) {
    return member.has(obj);
  } else {
    return __typeError("Cannot " + msg);
  }
};
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => (member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value));
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

/* ---------------------------------------------
 *  LoadMore Web Component
 * --------------------------------------------- */
var _listSelector, _nextUrl, _abortCtrl, _button, _loading, _load_times, _LoadMore_instances, fetchNext_fn, updateButton_fn, cleanup_fn, reveal_fn;

var LoadMore = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _LoadMore_instances);
    __privateAdd(this, _listSelector, "");
    __privateAdd(this, _nextUrl, "");
    __privateAdd(this, _abortCtrl, new AbortController());
    __privateAdd(this, _button, null);
    __privateAdd(this, _loading, false);
    __privateAdd(this, _load_times, 0);
  }

  connectedCallback() {
    __privateSet(this, _listSelector, this.dataset.list || "");
    __privateSet(this, _nextUrl, this.dataset.next || "");
    __privateSet(this, _button, this.querySelector("button"));
    if (!__privateGet(this, _button) || !__privateGet(this, _listSelector)) {
      return;
    }
    __privateGet(this, _button).addEventListener("click", __privateMethod(this, _LoadMore_instances, fetchNext_fn).bind(this), { signal: __privateGet(this, _abortCtrl).signal });
    inView(this, () => {
      if (__privateGet(this, _load_times) < 2) {
        __privateMethod(this, _LoadMore_instances, fetchNext_fn).call(this);
        //! By default, the provided callback will fire just once, unless set the leaving view callback
        return () => {};
      }
    });
  }

  disconnectedCallback() {
    __privateMethod(this, _LoadMore_instances, cleanup_fn).call(this);
  }
};
_listSelector = new WeakMap();
_nextUrl = new WeakMap();
_abortCtrl = new WeakMap();
_button = new WeakMap();
_loading = new WeakMap();
_load_times = new WeakMap();
_LoadMore_instances = new WeakSet();

reveal_fn = function () {
  __privateSet(this, _load_times, __privateGet(this, _load_times) + 1);
  animate(
    Array.from(document.querySelector(__privateGet(this, _listSelector))?.querySelectorAll('product-card[reveal-on-scroll="true"]') || []).filter((el) => getComputedStyle(el).opacity === "0"),
    {
      opacity: [0, 1],
      transform: ["translateY(20px)", "translateY(0)"],
    },
    {
      duration: 0.2,
      easing: "ease-in-out",
      delay: stagger(0.05, { start: 0.4, easing: "ease-out" }),
    },
  );
};

fetchNext_fn = async function () {
  if (__privateGet(this, _loading) || !__privateGet(this, _nextUrl)) return;
  __privateSet(this, _loading, true);
  __privateMethod(this, _LoadMore_instances, updateButton_fn).call(this, true);

  try {
    const res = await fetch(__privateGet(this, _nextUrl), { signal: __privateGet(this, _abortCtrl).signal });
    if (!res.ok) throw new Error(res.status);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    /* 1. add new nodes */
    const newNodes = doc.querySelector(__privateGet(this, _listSelector))?.innerHTML;
    if (newNodes) {
      const listEl = document.querySelector(__privateGet(this, _listSelector));
      listEl?.insertAdjacentHTML("beforeend", newNodes);
      __privateMethod(this, _LoadMore_instances, reveal_fn).call(this);
      this.dispatchEvent(new CustomEvent("load-more:loaded", { detail: { html: newNodes } }));
    }

    /* 2. get next url */
    const nextLink = doc.querySelector('link[rel="next"]')?.href;
    __privateSet(this, _nextUrl, nextLink || "");
    if (!__privateGet(this, _nextUrl)) {
      /* if no next url, remove the button */
      this.dispatchEvent(new CustomEvent("load-more:complete"));
      __privateGet(this, _button).hidden = true;
      __privateMethod(this, _LoadMore_instances, cleanup_fn).call(this);
    }
  } catch (err) {
    if (err.name !== "AbortError") {
      this.dispatchEvent(new CustomEvent("load-more:error", { detail: { error: err } }));
    }
  } finally {
    __privateSet(this, _loading, false);
    __privateMethod(this, _LoadMore_instances, updateButton_fn).call(this, false);
  }
};

updateButton_fn = function (loading) {
  const btn = __privateGet(this, _button);
  if (!btn) return;
  btn.disabled = loading;
  btn.setAttribute("aria-busy", loading);
  // todo: loading效果
  btn.querySelector(".load-more__text") && (btn.querySelector(".load-more__text").textContent = loading ? this.dataset.loadingText || "Loading…" : this.dataset.loadMoreText || "Load more");
};

cleanup_fn = function () {
  __privateGet(this, _abortCtrl).abort();
  __privateSet(this, _button, null);
};

if (!window.customElements.get("load-more")) {
  window.customElements.define("load-more", LoadMore);
}
